import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import ManufactureBoard from "./components/ManufactureBoard/ManufactureBoard";

export default function ManufactureEdit() {
  const navigate = useNavigate();
  const params = useParams();
  const manufacture_edit = hasPrivilege('manufacture_edit');

  useEffect(() => {
    if (!manufacture_edit) {
      navigate("/");
    }
  }, [navigate, manufacture_edit])

  if (manufacture_edit) {
    const editable = true;
    const ident = params.id;

    return (
      <div>
        <ManufactureBoard editable={editable} ident={ident} />
      </div>
    )
  }
}
